import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=738cdfc5&scoped=true&lang=pug&"
import script from "./CommonSection.vue?vue&type=script&lang=js&"
export * from "./CommonSection.vue?vue&type=script&lang=js&"
import style0 from "./CommonSection.vue?vue&type=style&index=0&id=738cdfc5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cdfc5",
  null
  
)

export default component.exports